// extracted by mini-css-extract-plugin
export default {"loading-wrap":"loading-wrap_sg3__"};